import BracketParser from './logic/bracketparser/bracketparser/BracketParser.js';
export default BracketParser;